import React, { useState } from 'react';
import './VisaSelection.css';
import passport from "../assets/mdi_passport.png";
import calendar from "../assets/ri_calendar-fill.png";
import entry from "../assets/healthicons_entry.png";
import processing from "../assets/mdi_passport-2.png";

const visaTypes = ['Tourist', 'Business', 'Student', 'Work'];
const validityOptions = ['30 Days', '90 Days', '180 Days', '365 Days'];

const VisaSelection = () => {
  const [selectedVisaType, setSelectedVisaType] = useState(visaTypes[0]);
  const [selectedValidity, setSelectedValidity] = useState(validityOptions[0]);
  const [expanded, setExpanded] = useState(false);

  const toggleExpanded = () => {
    setExpanded(!expanded);
  };

  return (
    <div>
      <div className='selector-wrapper'>
        <select
          value={selectedVisaType}
          onChange={(e) => setSelectedVisaType(e.target.value)}
          className="visa-type-select"
        >
          {visaTypes.map((type) => (
            <option key={type} value={type}>
              {type}
            </option>
          ))}
        </select>
    </div>

      <div style={{background:'#ffffff',borderRadius:'20px',border:'1px solid #541c9c'}}>
       
        <div>

        </div>
          <div style={{display:'flex',justifyContent:'space-between',paddingLeft:'15px',paddingRight:'15px'}}>
            <div className='visadata'>
              <div>
                <img src={passport}></img>
              </div>
              <div className='visadatainfo'>
                <div>Visa Type</div>
                <div style={{color:'green',fontWeight:'500'}}>E-Visa</div>
              </div>
            </div>

            <div className='visadata'>
              <div>
                <img src={calendar}></img>
              </div>
              <div className='visadatainfo'>
                <div>Length of Stay</div>
                <div style={{color:'green',fontWeight:'500'}}>10 days</div>
              </div>
            </div>

            <div className='visadata'>
              <div>
                <img src={entry}></img>
              </div>
              <div className='visadatainfo'>
                <div>Entry</div>
                <div style={{color:'green', fontWeight:'500'}}>Single</div>
              </div>
            </div>

            <div className='visadata'>
              <div>
                <img src={processing}></img>
              </div>
              <div className='visadatainfo'>
                <div>Processing Time</div>
                <div style={{color:'green',fontWeight:'500'}}>5 Days</div>
              </div>
            </div>
      </div>
          

            
          </div>
      </div>
  );
};

export default VisaSelection;